<section class="smartpos-page">
  <header>
    <p class="eyebrow"><i class="fe-smartphone" aria-hidden="true"></i> Equipamentos · Maquininhas</p>
    <h1>Smart POS</h1>
    <p>Vincule as maquininhas que vão atender mesas e balcão com o app MeuCardápio. Cada aparelho só acessa esta loja.</p>
  </header>

  <p class="erro" *ngIf="erro" role="alert">{{ erro }}</p>

  <div class="licencas" *ngIf="!carregando" [class.inativo]="!licencas.moduloAtivo" role="status">
    <ng-container *ngIf="licencas.moduloAtivo">
      <strong>{{ licencas.emUso }} de {{ licencas.contratadas }} licenças em uso</strong>
      <span *ngIf="!licencasEsgotadas">Você pode vincular mais {{ licencas.contratadas - licencas.emUso }} maquininha(s).</span>
      <span *ngIf="licencasEsgotadas">Todas as licenças estão em uso. Para vincular outra maquininha, revogue um terminal ou fale com o suporte para ampliar.</span>
    </ng-container>
    <ng-container *ngIf="!licencas.moduloAtivo">
      <strong>Módulo Smart POS não contratado</strong>
      <span><ng-container *ngIf="licencas.valorMensalTerminal">{{ licencas.valorMensalTerminal | currency:'BRL':'symbol':'1.2-2' }} por terminal ao mês. </ng-container>Fale com o suporte do MeuCardápio para contratar.</span>
    </ng-container>
    <small>O simulador usado em testes não consome licença.</small>
  </div>

  <div class="workspace">
    <section class="vincular" aria-labelledby="titulo-vincular">
      <h2 id="titulo-vincular">Vincular maquininha</h2>
      <ng-container *ngIf="!codigo">
        <p class="subtitulo">Dê um nome ao terminal e gere um código. No app da maquininha, informe o endereço da loja e esse código.</p>
        <form (ngSubmit)="gereCodigo()">
          <label class="campo">Nome do terminal
            <input type="text" name="nomeTerminal" [(ngModel)]="nomeTerminal" maxlength="80" placeholder="Ex.: Caixa 1, Salão">
          </label>
          <button class="primary" type="submit" [disabled]="!nomeTerminal.trim() || gerando || !licencas.moduloAtivo">{{ gerando ? 'Gerando…' : 'Gerar código' }}</button>
        </form>
      </ng-container>

      <div class="codigo" *ngIf="codigo" aria-live="polite">
        <span class="rotulo">Código para {{ codigo.nomeTerminal }}</span>
        <div class="valor">{{ codigo.codigo }}</div>
        <span class="validade" *ngIf="segundosRestantes > 0">Válido por {{ tempoRestante }} · uso único</span>
        <span class="validade expirado" *ngIf="segundosRestantes === 0">Código expirado. Gere outro.</span>
        <p class="subtitulo">O código não fica salvo: depois de fechar esta caixa não é possível vê-lo de novo.</p>
        <button class="secondary" type="button" (click)="fecheCodigo()">Concluído</button>
      </div>
    </section>

    <section class="lista" aria-labelledby="titulo-lista">
      <div class="lista-topo">
        <h2 id="titulo-lista">Terminais vinculados</h2>
        <button class="text-button" type="button" (click)="carregue()" [disabled]="carregando">Atualizar</button>
      </div>
      <p class="subtitulo" *ngIf="carregando">Carregando…</p>
      <p class="subtitulo" *ngIf="!carregando && !ativos.length">Nenhuma maquininha vinculada.</p>

      <ul *ngIf="ativos.length">
        <li *ngFor="let t of ativos" class="terminal">
          <div class="info">
            <strong>{{ t.nome }}</strong>
            <span>{{ nomeProvedor(t.provedor) }}<ng-container *ngIf="t.terminalModelo"> · {{ t.terminalModelo }}</ng-container><ng-container *ngIf="t.versaoApp"> · app {{ t.versaoApp }}</ng-container></span>
            <span class="nota">Vinculado em {{ t.vinculadoEm | date:'dd/MM/yyyy HH:mm' }}<ng-container *ngIf="t.vinculadoPor"> por {{ t.vinculadoPor.nome }}</ng-container></span>
            <span class="nota">Último contato: {{ t.ultimoContatoEm ? (t.ultimoContatoEm | date:'dd/MM/yyyy HH:mm') : '—' }}</span>
          </div>
          <span class="selo simulador" *ngIf="t.provedor === 'SIMULADOR'">Teste</span>
          <button class="text-button perigo" type="button" (click)="abraRevogacao(t)">Revogar</button>
        </li>
      </ul>

      <details *ngIf="revogados.length">
        <summary>Revogados <span>{{ revogados.length }}</span></summary>
        <ul>
          <li *ngFor="let t of revogados" class="terminal revogado">
            <div class="info">
              <strong>{{ t.nome }}</strong>
              <span class="nota">Revogado em {{ t.revogadoEm | date:'dd/MM/yyyy HH:mm' }}<ng-container *ngIf="t.revogadoPor"> por {{ t.revogadoPor.nome }}</ng-container></span>
              <span class="nota">Motivo: {{ t.motivoRevogacao }}</span>
            </div>
          </li>
        </ul>
      </details>
    </section>
  </div>

  <div class="dialogo-fundo" *ngIf="revogando" (click)="revogando = null"></div>
  <div class="dialogo" *ngIf="revogando" role="dialog" aria-modal="true" aria-labelledby="titulo-revogar">
    <h2 id="titulo-revogar">Revogar {{ revogando.nome }}</h2>
    <p class="subtitulo">A maquininha deixa de iniciar operações imediatamente e o operador conectado é desconectado.</p>
    <label class="campo">Motivo
      <input type="text" [(ngModel)]="motivoRevogacao" maxlength="255" placeholder="Ex.: aparelho perdido, troca de equipamento">
    </label>
    <div class="acoes">
      <button class="text-button" type="button" (click)="revogando = null">Cancelar</button>
      <button class="primary perigo" type="button" (click)="confirmeRevogacao()" [disabled]="!motivoRevogacao.trim() || salvandoRevogacao">
        {{ salvandoRevogacao ? 'Revogando…' : 'Revogar terminal' }}
      </button>
    </div>
  </div>
</section>
